<div class="dark text-justify scroll-box">
  <div class="info-header">
    <h4 class="info-title">{{ 'Terms & Conditions' | translate }}</h4>
  </div>
  <hr>

  <ng-container *ngIf="termsConditions_main.length > 0 && !isSkeletonTermsConditionsMain; else skeletonTermsConditionsMain">
    <div class="p-1 faq-page-title" [innerHTML]="sanitize(termsConditions_main)"></div>
  </ng-container>

  <ng-template #skeletonTermsConditionsMain>
    <ng-container *ngIf="isSkeletonTermsConditionsMain">
      <ng-container *ngFor="let item of [].constructor(4)">
        <p class="skeleton skeleton-text mb-1"></p>
      </ng-container>
      <p class="skeleton skeleton-text mb-3 w-75"></p>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="termsConditionsLength > 0 && !isSkeletonTermsConditionsMain; else skeletonTermsConditionsLength">
    <div class="container p-l-0 p-r-0">
      <mat-accordion class="vip-faq">
        <mat-expansion-panel *ngFor="let tnc of termsConditions" (opened)="panelOpenState = true" (afterExpand)="scroll(tnc.id)" (closed)="panelOpenState = false" hideToggle class="m-b-10">
          <mat-expansion-panel-header>
            <mat-panel-title [id]="tnc.id">
              {{ tnc.title }}
              <i class="icon-chevron-down dropdown-arrow-img"></i>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p class="en-tnc-p" [innerHTML]="sanitize(tnc.description)"></p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>

  <ng-template #skeletonTermsConditionsLength>
    <ng-container *ngIf="isSkeletonTermsConditionsMain">
      <div *ngFor="let item of [].constructor(5) | slice:0:1">
        <mat-accordion class="faq-section">
          <ng-container *ngFor="let item of [].constructor(5)">
            <mat-expansion-panel class="m-b-15 border-0 skeleton-faq-mat-header">
              <mat-expansion-panel-header class="skeleton"></mat-expansion-panel-header>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
    </ng-container>
  </ng-template>
</div>
